var _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTestimonialBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 263,
    height: 221,
    viewBox: "0 0 263 221",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 188,
    y: 76,
    width: 75,
    height: 75,
    fill: "#DDDDDD",
    fillOpacity: 0.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 151,
    y: 76,
    width: 75,
    height: 75,
    fill: "#DDDDDD",
    fillOpacity: 0.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 151,
    y: 37,
    width: 75,
    height: 75,
    fill: "#DDDDDD",
    fillOpacity: 0.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 146,
    width: 75,
    height: 75,
    fill: "#DDDDDD",
    fillOpacity: 0.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 113,
    width: 150,
    height: 75,
    fill: "#333333"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 112,
    width: 75,
    height: 75,
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestimonialBg);
export default __webpack_public_path__ + "static/media/testimonial-bg.68792c497c0c19f55f7667b87283b857.svg";
export { ForwardRef as ReactComponent };